<template>
  <div>
    <van-row>
      <van-col
        :span="24"
        v-if="classDetial.acttypeid == 3 && classDetial.status != 1"
        class="m-b-05"
      >
        <van-row :style="title">
          <van-col :span="14" class="colorW p-l-75 title" style="min-height:2.7rem">

            <div v-if="classDetial.status == 2" style="width:100%">
              <p class="m-l-02 f-s-6 m-t-10 f-l-l">¥</p>
              <p class="m-l-02 f-s-016 f-l-l">
                {{ classDetial.courseOriginal }}
              </p>
              <div class="f-l-l m-l-03 m-t-02">
                <p class="f-s-6 text-c group">团购</p>
                <p class="f-s-6">
                  <span>{{ classDetial.courseXnum }}人购买</span>
                </p>
              </div>
            </div>

            <div v-if="classDetial.status == 3">
              <p class="f-l-09 p-l-75 Countdown">拼团倒计时</p>
            </div>
          </van-col>

          <van-col :span="9">
            <!-- <p class="text-c activeTime f-s-6 m-t-045 p-r-75">活动倒计时</p> -->
            <van-count-down
              :time="classDetial.actendTime - new Date().getTime()"
              class="f-s-6 m-t-10 m-l-08"
            >
              <template #default="timeData">
                <span class="colorRed">{{
                  Math.floor(timeData.days)
                }}</span>
                <span class="colorRed m-l-02">天</span>
                <span class="block m-l-02">{{ timeData.hours }}</span>
                <span class="colon">:</span>
                <span class="block m-l-02">{{ timeData.minutes }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </van-col>
        </van-row>
      </van-col>

      <van-col :span="24" class="p-l-05 p-t-10 bg-white">
        <p class="f-s-09">{{ classDetial.courseTitle }}</p>
        <p class="title_time f-s-65 m-b-05 m-t-3">
          {{ classDetial.startTime }} 至 {{ classDetial.endTime }} |
          {{ classDetial.ccount }}课时
        </p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  props: {
    classDetial: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      time: 0,
      title: {
        background:
          "url(" + require("@/assets/imgs/class/classBg.png") + ") no-repeat",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        width:"100%"
      },
    };
  },
};
</script>

<style scoped>
.Countdown {
  color: #ffffff;
  height: 2.5rem;
  line-height: 2.5rem;
}
.colorRed {
  color: #e84c27;
}
.title_time {
  color: #657081;
}
.colon {
  display: inline-block;
  margin: 0 1px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #ee0a24;
}
.activeTime {
  color: #e84c27;
}
.title {
  padding-top: 0.3rem;
  /* padding-bottom: 0.3rem; */
}
.title_label {
  width: 1.4rem;
  background: #dc1916;
  padding: 0.1rem;
  padding-left: 0.2rem;
  border-radius: 0.1rem;
}
.group {
  width: 2.15rem;
  color: #e74c27;
  background-color: white;

  border-radius: 1px;
}
</style>